import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative overflow-hidden bg-brand-bg pt-10 pb-16 lg:pt-16 lg:pb-20" data-id="element-73">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-74">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-75">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="flex flex-col items-center lg:items-start text-center lg:text-left order-2 lg:order-1" data-id="element-76">
            <span className="text-sm tracking-[0.2em] text-brand-subtext font-semibold uppercase mb-6" data-id="element-77">
              Casa Calma Candle
            </span>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-78">
              🕯️ Aprende a Hacer Velas Aromáticas y Vende tu Primera Colección
              en 7 Días.
            </h1>

            <p className="text-xl text-brand-subtext mb-8 font-medium" data-id="element-79">
              Solo PDF | Descarga Inmediata | En Español
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative order-1 lg:order-2" data-id="element-80">
            <div className="absolute inset-0 bg-brand-accent rounded-3xl transform rotate-3 scale-105 opacity-50" data-id="element-81"></div>
            <img src="https://cdn.magicpatterns.com/uploads/ktoY16pQjoEuZu8e7rUkyw/academia_de_velas_aromaticas.png" alt="Academia de Velas Aromáticas PDF en un iPad junto a una vela encendida" className="relative z-10 rounded-2xl shadow-2xl w-full object-cover aspect-[4/5] lg:aspect-square" data-id="element-82" />
          </motion.div>
        </div>
      </div>
    </section>;
}